<template>
  <select-artist
    :is-shown="isShown"
    :selected-ids="selectedIds"
    :excluded-ids="excludedIds"
    modal-name="selectMainArtist"
    modal-class="select-main-artist-modal"
    title="メインアーティスト選択"
    :artist-type="1"
    :kana-optional="true"
    @close="onClose"
    @select="onSelect"/>
</template>

<script>
import SelectArtist from './SelectArtist'

export default {
  name: 'SelectMainArtist',
  components: { SelectArtist },
  props: {
    isShown: {
      type: Boolean,
      default: false,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
    excludedIds: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onSelect(artists) {
      this.$emit('select', artists)
    },
  },
}
</script>
